if (!customElements.get("product-info-tabs")) {
  class Tabs extends HTMLElement {
    constructor() {
      super();

      // Tabs script
      const navLinks = this.querySelectorAll("[data-nav]");
      const tabs = this.querySelectorAll("[data-tab]");

      // Make first tab active by default
      tabs[0].classList.remove("hidden", "opacity-0");

      // Toggle nav and tab
      navLinks.forEach((link, index) => {
        const target = link.dataset.target;
        let targetTabs = this.querySelectorAll(target);

        // Make first nav active by default
        if (index === 0) {
          link.classList.add("active");
          targetTabs.forEach(function(targetTab){
            targetTab.classList.remove("hidden", "opacity-0");
          });
        }

        //link.addEventListener('touchstart', handler, false);
        link.addEventListener('click', handler, false);

        function handler(event) {

          link = event.target;

          if (!event.target.dataset.nav) {
            link = event.target.closest('[data-nav]');
          }

          if (window.innerWidth > 767) {
            navLinks.forEach((navLink) => navLink.classList.remove("active"));
            tabs.forEach((tab) => tab.classList.add("hidden", "opacity-0"));
          }

          targetTabs = document.querySelectorAll(target);

          if (link.classList.contains('active')) {
            link.classList.remove("active");
            targetTabs.forEach(function(targetTab){
              targetTab.classList.add("hidden", "opacity-0");
            });
          } else {
            link.classList.add("active");
            targetTabs.forEach(function(targetTab){
              targetTab.classList.remove("hidden", "opacity-0");
            });
          }
        }

      });
    }
  }
  customElements.define("product-info-tabs", Tabs);
}
